import type {CourseExpandedCommon} from '../../../api/course';
import type {Nullable} from '../../../utils/utility-types';

import {currentUserStore} from '../../../api/user';

export const canCourseBeStarted = (course?: Nullable<CourseExpandedCommon>) => {
  if (!course) {
    return false;
  }

  const isMainCoach = course.user_id === currentUserStore.user?._id;

  if (course.program?.status === 'archived') {
    return false;
  }

  return (
    isMainCoach &&
    course.counters.memberships.accepted > 0 &&
    course.status === 'planned'
  );
};
